module.exports = __webpack_public_path__ + "static/img/productimg9.2656b793.png";